const en = {
  qualified: {
    title: 'Thank you for completing this study!',
    text: 'You are free to close down the browser window.\n\nWe hope to see you again soon.',
  },
  quotaFull: {
    title: 'This study is closed',
    text: 'Thank you for your interest in our study.\n\nUnfortunately we have already received all the responses we need.\n\nWe hope to see you in one of our future studies!',
  },
  terminated: {
    title: 'Thank you for sharing your feedback!',
    text: 'We hope to see you soon in our future studies. Until then, we wish you a great day.\n\nPlease close down this browser window.',
  },
  mismatch: {
    title: 'Thank you for your answers!',
    text: 'Unfortunately, you’re not a match for the target group we’re looking for in this particular study.\n\nWe appreciate you taking the time to answer our questions and hope to invite you to another study soon.\n\nYou can close this page.',
  },
  error: {
    title: 'We are not able to serve your request',
    linkProblemDetailed:
      'The link you have followed is having problems. Please check that the link in the address line matches the one given to you and try again.',
    linkProblemGeneric:
      'The link you have followed is having problems. Please try again.',
    contactPerson:
      'If the problem persist, please let the person you got the link from, know about this is issue.',
  },
};

export type FeedbackMessages = typeof en;
export default en;
